import { Maybe } from '@csp/csp-common-model';
import { CriteriaType, QueryV1 } from '@csp/dmdp-api-common-dto';
import { OrganizationCriteriaFieldV1, OrgType } from '@csp/dmdp-api-org-dto';

const toTypesQuery = (orgTypes: OrgType[], query: Maybe<Omit<QueryV1, 'criterion'>>): QueryV1 => ({
  ...query,
  criterion: {
    fieldCriterion: {
      type: CriteriaType.IN,
      field: OrganizationCriteriaFieldV1.TYPE,
      values: orgTypes,
    },
  },
});

export const OrgQueryFactory = {
  toTypesQuery,
};
